import { useState } from "react";

const useLocalStorage = (keyName, defaultValue) => {
  const _getStoredLocalValue = () => {
    try {
      const value = window.localStorage.getItem(keyName);
      if (value) {
        return JSON.parse(value);
      } else {
        window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  };

  const [storedLocalValue, _setStoredLocalValue] = useState(() =>
    _getStoredLocalValue()
  );

  const setStoredLocalValue = (newValue) => {
    try {
      window.localStorage.setItem(keyName, JSON.stringify(newValue));
    } catch (err) {}
    _setStoredLocalValue(newValue);
  };
  return [storedLocalValue, setStoredLocalValue];
};

export default useLocalStorage;
